export default __webpack_public_path__ + "static/media/xp_icon.0bb946eb.svg";